import { PauseCircleIcon } from './PauseCircleIcon';

/**
 * author: Google
 * id 7AA13CBC-D472-4462-8263-88DA2BDCD6BB
 * name pause-circle
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pause-circle.svg
 * tags
 */
export const PauseCircleFilledIcon = PauseCircleIcon;
export default PauseCircleFilledIcon